import { Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { DevManagementDataService } from "@app/admin/services/devmanagement.service";
import { KeyValue } from "@models/generic/KeyValuePair";
import { ToastrService } from "ngx-toastr";
import { CerrixPromptService } from "@app/shared/services/cerrix-prompt.service";
import { CheckboxComponent } from "@app/shared/cerrix-checkbox/cerrix-checkbox.component";
import { TranslatePipe, injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/admin/i18n/scope";

@Component({
    selector: "dev-code-executions",
    templateUrl: "./dev-code-executions.component.html",
    styleUrls: ["./dev-code-executions.component.scss"],
    imports: [FormsModule, NgSelectModule, CheckboxComponent, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class DevCodeExecutionComponent {
    private _ds = inject(DevManagementDataService);
    private _toastr = inject(ToastrService);
    private _promptService = inject(CerrixPromptService);
    private translation = injectTranslation(scope);

    executables: KeyValue<number, string>[];

    selectedExecutable: number;
    testrunSelected = true;
    executionMessage: string;

    constructor() {
        this._ds.getAvailableExecutables().subscribe((x) => {
            this.executables = x;
            this.selectedExecutable = this.executables[0].Key;
        });
    }

    async execute() {
        await this.translation.ready();
        const executableName = this.executables.find((x) => x.Key === this.selectedExecutable)
            .Value;
        const executionConfirmMessage = this.translation.t(
            this.testrunSelected
                ? "devCodeExecutions.testrunConfirmMessage"
                : "devCodeExecutions.executeConfirmMessage",
        );

        this._promptService
            .confirm(executableName, executionConfirmMessage)
            .onConfirm()
            .subscribe(() => {
                this._ds
                    .executeExecutable(this.selectedExecutable, this.testrunSelected)
                    .subscribe((res) => {
                        this.executionMessage = res;
                        if (!this.executionMessage || this.executionMessage.trim().length === 0) {
                            this._toastr.success(
                                "",
                                this.translation.t("devCodeExecutions.codeExecutionSucceeded"),
                            );
                        }
                    });
            });
    }
}
